import { ajaxActions } from '../AjaxActions';

const BASE_URL = process.env.REACT_APP_DOCUMENT_SERVICE_URL;

export const fetchBlockStyleById = (blockStyleId) =>
  ajaxActions.get(`${BASE_URL}/blockStyles/${blockStyleId}`).then((resp) => resp);

export const patchBlockStyleById = (blockStyleId, patch) =>
  ajaxActions.patch(`${BASE_URL}/blockStyles/${blockStyleId}`, patch).then((resp) => resp);
